(function () {
  'use strict';

  const angular = window.angular;

  HomeController.$inject = ['$uibModal', '$state', '$rootScope'];

  angular.module('app').component('memberHome', {
    template:'<div class="page-header"><h1 class="no-margin" style="border-bottom: 0"><i class="fas fa-home fa-fw"></i> <span class="header-text"><span translate>general.welcome</span> {{$ctrl.user.name}}</span></h1><div class="container"><ul class="nav nav-tabs nav-justified"><li ui-sref-active="active"><a ui-sref="member.home.vars" translate>entities.organization.var.modelNamePl</a></li><li ui-sref-active="active"><a ui-sref="member.home.configs" translate>entities.user.others.globalConfigs</a></li></ul></div></div><div class="container"><ui-view></ui-view></div>',
    controller: HomeController,
    bindings: {
      user: '<',
      vars: '<',
    },
  });

  function HomeController($uibModal, $state, $root) {
    let vm = this;

    vm.$onInit = function () {
      $root.varId = undefined;
    };
  }
})();
